import mapActions from './mapActions';

export default mapActions('entity_operations');
